'use client';
import React from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { Home, Plane, CreditCard, Hotel, User } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const NAV_ITEMS = [
  { key: 'nav-home', label: 'Home', icon: Home, href: '/' },
  { key: 'nav-hotels', label: 'Hotels', icon: Hotel, href: '/hotels' },
  { key: 'nav-flights', label: 'Flights', icon: Plane, href: '/flights' },
  { key: 'nav-payment', label: 'Pay', icon: CreditCard, href: '/payment' },
  { key: 'nav-profile', label: 'Profile', icon: User, href: '/user-dashboard' },
];

export default function MobileBottomNav() {
  const pathname = usePathname();
  const router = useRouter();

  const isActive = (href: string) => {
    if (href === '/') return pathname === '/' || pathname === '/home';
    return pathname?.startsWith(href);
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 lg:hidden"
      style={{ boxShadow: '0 -4px 20px rgba(0,0,0,0.08)', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      role="navigation"
      aria-label="Mobile navigation"
    >
      <div className="flex items-center justify-around px-1 pt-1 pb-2">
        {NAV_ITEMS?.map((item) => {
          const Icon = item?.icon;
          const active = isActive(item.href);
          return (
            <button
              key={item?.key}
              onClick={() => router?.push(item?.href)}
              className={`flex flex-col items-center gap-0.5 px-2 py-1.5 rounded-xl transition-all duration-200 flex-1 min-h-[52px] tap-highlight-none
                ${active ? 'text-primary-500' : 'text-gray-400 hover:text-gray-600'}`}
              aria-label={item?.label}
              aria-current={active ? 'page' : undefined}
            >
              <div className={`p-1.5 rounded-xl transition-all duration-200 ${active ? 'bg-primary-50' : ''}`}>
                <Icon size={20} strokeWidth={active ? 2.5 : 1.8} />
              </div>
              <span
                className={`text-[10px] font-display truncate leading-none ${active ? 'font-700' : 'font-500'}`}
                style={{ fontWeight: active ? 700 : 500 }}>
                {item?.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}